module.exports = __webpack_public_path__ + "static/media/hp_ex_sales.72d1eae0.jpg";